<cheelee-dialog-wrapper class="get-app">
  <div
    class="get-app__header"
    ngProjectAs="header"
  >
    <div class="get-app__image">
      <cheelee-image
        [alt]="'Earn in Cheelee'"
        [ngSrc]="'./assets/img/banner/banner_img-' + (picture() ?? pictureData ?? getRandomPicture) + '@x2.png'"
        [width]="192"
        [height]="120"
        loaderSize="m"
        priority
      />
    </div>

    <div class="get-app__close-btn">
      <button
        cheeleeRipple
        isCenteredRipple
        (click)="close()"
      >
        <cheelee-icon
          iconId="cross-icon"
          color="#AB9BFD"
        />
      </button>
    </div>
  </div>

  <div class="get-app__content">
    <p class="get-app__download-text">{{ 'common:join the cheelee' | i18nextEager }}</p>
    <p class="get-app__download-text">{{ 'common:watch video and earn' | i18nextEager }}</p>

    <div class="apps-links">
      <a [analytics]="analyticsEvents.ModalGoToCheeleeTap" target="_blank"
         href="https://apk-cdn.cheelee.us/cheelee.apk">
        <img src="/assets/img/modal/dapk-4.png" alt="" width="165" height="50"></a>
      <a [analytics]="analyticsEvents.ModalGoToCheeleeTap" target="_blank"
         href="https://global.app.mi.com/details?lo=ID&la=en&id=io.cheelee.app">
        <img src="/assets/img/modal/ga-4.png" alt="" width="165" height="50"></a>
      <a [analytics]="analyticsEvents.ModalGoToCheeleeTap" target="_blank"
         href="https://galaxystore.samsung.com/detail/io.cheelee.app">
        <img src="/assets/img/modal/gs-4.png" alt="" width="165" height="50"></a>
    </div>
  </div>

<!--  <div class="get-app__action-button">-->
<!--    <cheelee-button-->
<!--      withFullWidth-->
<!--      (clicked)="onButtonClick()"-->
<!--      [analytics]="analyticsEvents.ModalGoToCheeleeTap"-->
<!--    >-->
<!--      {{ 'common:to go to cheelee' | i18nextEager }}-->
<!--    </cheelee-button>-->
<!--  </div>-->

</cheelee-dialog-wrapper>
